const SORT_KEY = 'photo-g:schedule-employee-order';
export const SCHEDULE_SORT_OPTIONS = [
    { value: 'days', label: 'Больше дней в графике' },
    { value: 'created', label: 'Раньше создан аккаунт' },
    { value: 'current', label: 'По заполнению (как сейчас)' },
];
const validMode = value => SCHEDULE_SORT_OPTIONS.some(option => option.value === value);
export function savedScheduleSort() {
    try {
        const value = window.localStorage.getItem(SORT_KEY);
        return validMode(value) ? value : 'current';
    } catch { return 'current'; }
}
export function rememberScheduleSort(value) {
    if (!validMode(value)) return;
    try { window.localStorage.setItem(SORT_KEY, value); } catch { /* Sorting also works without browser storage. */ }
}
function timestamp(value, fallback) {
    const number = value ? Date.parse(value) : NaN;
    return Number.isFinite(number) ? number : fallback;
}
export function compareAccountCreated(first, second) {
    const a = timestamp(first.date_create, Infinity), b = timestamp(second.date_create, Infinity);
    return (a === b ? 0 : a < b ? -1 : 1) || Number(first.id) - Number(second.id);
}
export const EMPLOYEE_GROUP_SORT_OPTIONS = [
    { value: 'created', label: 'Сначала старые аккаунты' },
    { value: 'newest', label: 'Сначала новые аккаунты' },
    { value: 'name', label: 'По имени А–Я' },
];
export function sortEmployeeGroup(employees, mode = 'created') {
    const name = person => (person.full_name || `${person.first_name || ''} ${person.last_name || ''}`.trim() || person.email || '');
    return [...employees].sort((a, b) => {
        if (mode === 'name') return name(a).localeCompare(name(b), 'ru', { sensitivity: 'base' }) || compareAccountCreated(a, b);
        // Unknown creation dates stay at the bottom in either direction.
        const aMissing = !Number.isFinite(timestamp(a.date_create, NaN));
        const bMissing = !Number.isFinite(timestamp(b.date_create, NaN));
        if (aMissing !== bMissing) return Number(aMissing) - Number(bMissing);
        return mode === 'newest' ? compareAccountCreated(b, a) : compareAccountCreated(a, b);
    });
}
const adminRole = role => role === 'admin' || role === 'admin_photographer';
const legacyPriority = role => role === 'admin' ? 0 : role === 'admin_photographer' ? 1 : 2;
export function sortScheduleEmployees(employees, mode = 'current') {
    return [...employees].sort((a, b) => {
        if (mode === 'days' || mode === 'created') {
            const roles = Number(!adminRole(a.role)) - Number(!adminRole(b.role));
            if (roles) return roles;
            if (mode === 'days') {
                const days = new Set(b.availDays || []).size - new Set(a.availDays || []).size;
                if (days) return days;
            }
            return compareAccountCreated(a, b);
        }
        const roles = legacyPriority(a.role) - legacyPriority(b.role);
        if (roles) return roles;
        const filled = Number(!!b.availDays?.length) - Number(!!a.availDays?.length);
        return filled || timestamp(b.last_updated, 0) - timestamp(a.last_updated, 0);
    });
}
